import { Box, CircularProgress } from '@mui/material';

export function LoadingSpinner() {
  return (
    <Box display="flex" justifyContent="center" marginY={8}>
      <CircularProgress />
    </Box>
  );
}
